import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=526af24d&"
import script from "./Cards.vue?vue&type=script&lang=js&"
export * from "./Cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/janpencik/Sites/events/wp-content/plugins/event-feed-for-eventbrite/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526af24d')) {
      api.createRecord('526af24d', component.options)
    } else {
      api.reload('526af24d', component.options)
    }
    module.hot.accept("./Cards.vue?vue&type=template&id=526af24d&", function () {
      api.rerender('526af24d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/src/js/components/Cards.vue"
export default component.exports